var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7675 0.741898L15.5613 10.3604H21.0535L15.5613 28.6677L17.392 12.1911H11.8998L15.8551 0L0 7.04672V18.0311C0 28.1917 7.03004 37.6933 16.4766 40C25.9233 37.6933 32.9533 28.1917 32.9533 18.0311V7.04672L18.7675 0.741898Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUd);
export default __webpack_public_path__ + "static/media/ud.a757868c9c62131a29e30b3d9da0fa74.svg";
export { ForwardRef as ReactComponent };